// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U5F-","label":"styles_label__39mSn"};